import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=0ad97ff6&"
import script from "./TableCard.vue?vue&type=script&lang=js&"
export * from "./TableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad97ff6')) {
      api.createRecord('0ad97ff6', component.options)
    } else {
      api.reload('0ad97ff6', component.options)
    }
    module.hot.accept("./TableCard.vue?vue&type=template&id=0ad97ff6&", function () {
      api.rerender('0ad97ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/table-card/TableCard.vue"
export default component.exports